import { TemplateData, TemplateParams } from '.';

const calendarEventSettingsChanged = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'calendar-events',
  email: {
    buttonEnabled: true,
    buttonLink: '{{eventUrl}}',
    buttonText: messages.eventCalendarEventPage,
    content: `
      <p>
        ${messages.calendarEventEmailSettingsHasChanged}
        ${messages.calendarEventEmailSettingsNewDetails}:
      </p>
      <div style="margin-top: 15px;">
        {{eventDetails}}
      </div>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.calendarEventEmailSettingsChangedSubject}`
  },
  placeholders: {
    eventDetails: {
      label: messages.eventCalendarEventDetails,
      description: messages.eventCalendarEventDetailsDescription,
      example: ''
    },
    eventTitle: {
      label: messages.calendarEventTitle,
      example: 'Test event'
    },
    eventUrl: {
      label: messages.calendarEventLink,
      example: `${serverConfig.adminUrl}/calendar/1`
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeCalendarEventSettingsChanged
});

export default calendarEventSettingsChanged;
